export enum NonEssentialVendors {
	WOOTRIC = "Wootric",
	FEATURE_FEEDBACK_COLLECTOR = "Feature Feedback Collector",
	INTERCOM = "Intercom",
}

export type PartyType = "First Party" | "Third Party";

export interface VendorEntry {
	name: string;
	key?: string;
	description: string;
	vendorUrl: string;
	partyType: PartyType;
}

export interface PolicyCategory {
	policyName: string;
	vendors: VendorEntry[];
}

export interface VendorCatalog {
	essential: PolicyCategory;
	analytics: PolicyCategory;
}

export interface CookieConsentState {
	[policyName: string]: boolean;
}

export interface CookieConsentResult {
	consent: CookieConsentState;
	isGranted: (policyName: string) => boolean;
}

export interface AccessCookiePoliciesSDK {
	tabInitialise: (options: {
		config: {
			policies: Array<{ policyName: string }>;
			parties: Array<{
				partyName: string;
				partyType: PartyType;
				policies: Array<{
					policyName: string;
					vendorName: string;
					vendorUrl: string;
					description: string;
				}>;
			}>;
			applicationId: string;
			policyVersion: string;
			policyUrl: string;
		};
		language: string;
	}) => Promise<CookieConsentResult>;
}

declare global {
	interface Window {
		AccessCookiePolicies?: {
			SDK?: AccessCookiePoliciesSDK;
		};
	}
}
